import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    TFetchDDContextDFFColumnsRequestParams,
    fetchDFFColumns,
    IFetchDFFColumnsArgs,
} from './descriptive-flexfields-slice-api';
import {
    DRILLDOWN_DFF_TABLE_NAME,
    DESCRIPTIVE_FLEXFIELDS_SLICE,
} from './descriptive-flexfields-slice-constants';
import {IDescriptiveFlexfieldSegment} from './descriptive-flexfields-slice-types';

export const loadDDContextSegments = createAsyncThunk<
    IDescriptiveFlexfieldSegment[], TFetchDDContextDFFColumnsRequestParams>(
        `${DESCRIPTIVE_FLEXFIELDS_SLICE}/loadDDContextSegments`, async (args, {rejectWithValue}) => {
            try {
                const {contextCode} = args;
                const dffName = DRILLDOWN_DFF_TABLE_NAME;
                const {data} = await fetchDFFColumns({params: {contextCode, dffName}});
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadContextSegments = createAsyncThunk<
    IDescriptiveFlexfieldSegment[], IFetchDFFColumnsArgs>(
        `${DESCRIPTIVE_FLEXFIELDS_SLICE}/loadContextSegments`, async (args, {rejectWithValue}) => {
            try {
                const {data} = await fetchDFFColumns(args);
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
